// extracted by mini-css-extract-plugin
export var form = "_cj-0";